











import {
  defineComponent,
} from '@vue/composition-api';
import PrettyRadio from 'pretty-checkbox-vue/radio';

const RadioCheckboxWithIcon = defineComponent({
  components: { PrettyRadio },
  props: {
    icon: {},
    label: {},
    value: { default: false },
  },
  setup(props, { emit }) {
    function clickHandler() {
      emit('input', !props.value);
    }
    return { clickHandler };
  },
});

export default RadioCheckboxWithIcon;
